// extracted by mini-css-extract-plugin
export default {"inputFile":"InputFileUI_inputFile__8qSKJ","imageContainer":"InputFileUI_imageContainer__39F-U","imgItem":"InputFileUI_imgItem__+0cF1","img":"InputFileUI_img__1oBfG"};